import RegistrationNavBar from '@components/auth/navbar'
import PasswordLoginScreen from '@components/auth/password-login-screen'

const PasswordLogin = () => {
  return (
    <div className="flex flex-col slant-orange-split min-h-screen h-full">
      <RegistrationNavBar />
      <PasswordLoginScreen />
    </div>
  )
}

export default PasswordLogin
